export default "__VITE_ASSET__DzGThxvL__"